export default "__VITE_ASSET__laByT7zh__"